import { useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { StructuredData } from './structured-data';

/**
 * Organization/MedicalOrganization schema for site-wide structured data.
 * Should be included once per page, typically in the App or Page component.
 */
export const OrganizationSchema = () => {
    const { siteInfo } = useContext(AppContext);

    const isAtosCare = siteInfo.siteType === 'atos-care';
    const orgName = isAtosCare ? 'Atos Care' : 'Atos Medical';
    const baseUrl = `https://${siteInfo.currentDomain}`;

    const schema = {
        '@context': 'https://schema.org',
        '@type': isAtosCare ? 'Organization' : 'MedicalOrganization',
        name: orgName,
        url: baseUrl,
        logo: `${baseUrl}/assets/atos-logo.svg`,
        sameAs: [
            'https://www.linkedin.com/company/atos-medical/',
            'https://www.facebook.com/atosmedicalglobal/',
            'https://www.youtube.com/user/AtosMedical',
        ],
        ...(isAtosCare ? {} : {
            medicalSpecialty: 'Otolaryngologic',
            description: 'Atos Medical is a global leader in laryngectomy care, dedicated to improving the quality of life for people breathing through a stoma.',
        }),
    };

    return <StructuredData data={schema} />;
};
